import { put, select } from 'redux-saga/effects'
import * as tripInformationActions from '../store/tripInformation.actions'
import { IServiceConfig } from '../../configurations/store/configurations.types'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { getTripInformationOptionsSelector } from '../../options/selectors/tripInformationOptions.selector'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ITripInformationOptionsState } from '../../options/store/options.types'
import { IOption, IPNNVOption } from '../../../common/common.types'
import { getPcrIdSelector } from '../../home/selectors/getPcrId.selector'
import { hideDisableDateTimesBasedOnDisposition } from '../utils/tripInformation.util'
import { ITimesState } from '../../times/store/times.types'
import { getTimesSelector } from '../../times/selectors'
import { setTimes } from '../../times/store/times.actions'

export function* setTripInformationDefaults() {
  try {
    const pcrID: string = yield select(getPcrIdSelector)
    if (pcrID) {
      const serviceConfig: IServiceConfig = yield select(getServiceConfigSelector)
      const { SCENE_DEFAULT, SCHED_DEFAULT, MASSCAS_DEFAULT, OUTCOME_DEFAULT, EMD_DEFAULT, PR_DISP_FIELDS } =
        serviceConfig
      const times: ITimesState = yield select(getTimesSelector)

      const tripInfoOptions: ITripInformationOptionsState = yield select(getTripInformationOptionsSelector)
      const { massCasualtyOptions, dispositionOptions, typeofServiceOptions, scheduledOptions, emdPerformedOptions } =
        tripInfoOptions
      const dispositionOption = dispositionOptions.find((option) => option.id === OUTCOME_DEFAULT)
      const massCausalityOption = massCasualtyOptions.find((option) => option.id === MASSCAS_DEFAULT)
      const scheduledOption = scheduledOptions.find((option) => option.id === SCHED_DEFAULT)
      const typeofServiceOption = typeofServiceOptions.find((option) => option.id === SCENE_DEFAULT)

      let emdOption: IOption | null = null
      let emdPNNVOption: IPNNVOption | null = null
      if (PR_DISP_FIELDS) {
        emdOption = emdPerformedOptions.find((option) => option.id === EMD_DEFAULT) || null
        if (emdOption?.isPN || emdOption?.isNV) {
          emdPNNVOption = {
            id: emdOption.id as number,
            name: emdOption.name as string,
            pn: emdOption.isPN && emdOption.nemsisCode != null ? emdOption.nemsisCode.toString() : '',
            nv: emdOption.isNV && emdOption.nemsisCode != null ? emdOption.nemsisCode.toString() : '',
          }
        }
      }
      const updatedTimesWithDispositionConfig = hideDisableDateTimesBasedOnDisposition(dispositionOption ?? null, times)
      yield put(setTimes(updatedTimesWithDispositionConfig))

      if (dispositionOption) {
        yield put(tripInformationActions.setDisposition(dispositionOption))
      }
      if (massCausalityOption) yield put(tripInformationActions.setMassCasualty(massCausalityOption))
      if (scheduledOption) yield put(tripInformationActions.setScheduled(scheduledOption))
      if (typeofServiceOption) yield put(tripInformationActions.setTypeofService(typeofServiceOption))

      if (emdPNNVOption) yield put(tripInformationActions.setEmdPerformedPNNV(emdPNNVOption))
      else if (emdOption) yield put(tripInformationActions.setEmdPerformed(emdOption))
    }
  } catch (e) {
    yield put(throwPcrException(`setTripInformationDefaults() error: ${e}`))
  }
}
